<a class="file-container cursor-pointer" [href]="fileData.document_link" target="_blank">
  <div class="file-info">
    <img
    src="./assets/img/file-icons/{{ (mimeTypes[fileData?.mime_type] || fileData.type) || 'bin'}}.svg"
  />
    <p class="file-name">{{ fileData?.name }}</p>
  </div>
</a>
